// extracted by mini-css-extract-plugin
export var fadeInOut = "_3z-3";
export var icon = "_3z-4";
export var savedIndicator = "_3z-2";
export var savingIndicator = "_3z-0";
export var spin = "_3z-1";